/** Schermo stretto (telefono, sotto i 768 px): gli elenchi diventano schede al posto delle tabelle. */
import { Grid } from "antd";

export const useStretto = () => Grid.useBreakpoint().md === false;
